// import Cookies from "js-cookie";
import { csrfFetch } from '../utils/csrfFetch';
// Action Types
const LOAD_COMPANIES = "companies/LOAD_COMPANIES";

// Action Creators
export const loadCompanies = (companies) => ({
  type: LOAD_COMPANIES,
  payload: companies,
});

// Thunks
export const fetchCompaniesAdmin = () => async (dispatch) => {
  try {
    const response = await fetch('/api/companies', {
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (response.ok) {
      const companies = await response.json();
      dispatch(loadCompanies(companies));
    }
  } catch (error) {
    console.error('Error fetching companies:', error);
  }
};

export const fetchCompaniesUser = (accountId) => async (dispatch) => {
  try {
    const response = await csrfFetch('/api/companies/');

    if (response.ok) {
      const companies = await response.json();
      dispatch(loadCompanies(companies));
      return companies;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch companies');
    }
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
};

// Reducer
const initialState = [];

export default function companiesReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_COMPANIES:
      return action.payload;
    default:
      return state;
  }
}
